export default __webpack_public_path__ + "static/media/anselmo-paiva.28e321c9.png";